<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wSiD6B/tc-custom/9781504094573.jpg?1718282807506" alt="This image is the cover for the book February or Forever, Tarrin’s Bay"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">February or Forever, Tarrin’s Bay
      </h1>
      <p class="bookDescription body article font2">
        <p>What if you were hired to work with your favourite celebrity?<br/>  <br/> Yoga teacher and single mother, Chrissie Burns has a plan: move into the rundown beach house she’s inherited; the scene of a terrible accident years ago, renovate it, sell it, and move on.<br/>  <br/> But the town offers more than bad memories. The people are friendly, and even Chrissie's young son finds friends and begins coming out of his shell.<br/>  <br/> Employed at a retreat as a yoga instructor, Chrissie is shocked to discover she will be teaching Drew Williams, Australia's top singer songwriter.<br/>  <br/> Relationships between instructors and clients are strictly forbidden, but their attraction is undeniable.<br/>  <br/> And when it’s time for Drew to leave Tarrin’s Bay, can the romance last or is it doomed to fail?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Juliet Madison
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?86c9b2cc